import { createAction, props } from '@ngrx/store';
import { User, AuthState, LoginRequest, RegisterRequest, RegisterWithCodeRequest, RegisterCreateTenantRequest } from '../../shared/models';

/* Session Hydration */
export const hydrateSession = createAction(
  '[Auth] Hydrate Session',
  props<{ user: User; accessToken: string }>()
);

/* Login Actions */
export const login = createAction(
  '[Auth] Login',
  props<{ request: LoginRequest }>()
);
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; accessToken: string }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

/* Register Actions */
export const register = createAction(
  '[Auth] Register',
  props<{ request: RegisterRequest }>()
);
export const registerSuccess = createAction(
  '[Auth] Register Success',
  props<{ user: User; accessToken: string }>()
);
export const registerFailure = createAction(
  '[Auth] Register Failure',
  props<{ error: string }>()
);

/* Register with Code Actions */
export const registerWithCode = createAction(
  '[Auth] Register With Code',
  props<{ request: RegisterWithCodeRequest }>()
);
export const registerWithCodeSuccess = createAction(
  '[Auth] Register With Code Success',
  props<{ user: User; accessToken: string }>()
);
export const registerWithCodeFailure = createAction(
  '[Auth] Register With Code Failure',
  props<{ error: string }>()
);

/* Register Create Tenant Actions */
export const registerCreateTenant = createAction(
  '[Auth] Register Create Tenant',
  props<{ request: RegisterCreateTenantRequest }>()
);
export const registerCreateTenantSuccess = createAction(
  '[Auth] Register Create Tenant Success',
  props<{ user: User; accessToken: string; tenantId: string; isTemporaryAdmin: boolean }>()
);
export const registerCreateTenantFailure = createAction(
  '[Auth] Register Create Tenant Failure',
  props<{ error: string }>()
);

/* Logout Actions */
export const logout = createAction('[Auth] Logout');

/* Get Profile */
export const getProfile = createAction('[Auth] Get Profile');
export const getProfileSuccess = createAction(
  '[Auth] Get Profile Success',
  props<{ user: User }>()
);
export const getProfileFailure = createAction(
  '[Auth] Get Profile Failure',
  props<{ error: string }>()
);

/* MFA Actions */
export const enableMfa = createAction('[Auth] Enable MFA');
export const enableMfaSuccess = createAction(
  '[Auth] Enable MFA Success',
  props<{ secret: string; qrCode: string; backupCodes: string[] }>()
);
export const enableMfaFailure = createAction(
  '[Auth] Enable MFA Failure',
  props<{ error: string }>()
);

/* Clear Auth Error */
export const clearError = createAction('[Auth] Clear Error');
